import { Injectable } from '@angular/core';
import {Helper} from '../../utils/helper.module';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class OrganizationService {

  constructor(private http: HttpClient) {}

  pays(): Promise<any> {
    return this.http.get('assets/plugins/countries.js')
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }


  devises(): Promise<any> {
    return this.http.get(Helper.api('devises'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }


  statut(): Promise<any> {
    return this.http.get(Helper.api('statuts'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  organisation(): Promise<any> {
    return this.http.get(Helper.api('organisation'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  payment(): Promise<any> {
    return this.http.get(Helper.api('payments'))
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }


  saveorganization(organisation: any): Promise<any> {
    return this.http.post(Helper.api('organisations'), organisation)
      .toPromise()
      .then((response) => {
        console.log(response);
        return Promise.resolve(true);
      })
      .catch(this.handleError);
  }

  savepaiement(paiement: any): Promise<any> {
    return this.http.post(Helper.api('paiements'), paiement)
      .toPromise()
      .then((response) => {
        console.log(response);
        return Promise.resolve(true);
      })
      .catch(this.handleError);
  }


  // TODO: #MEDIUM repeated code
  // with ctach() use an arrow function in order to use the keyword this
  private handleError(error: any, redirectUrl?: string): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error.json());
  }

}
